import service from "@/utils/service";

/***** 朝代 *****************************************/
export function getDynasty(options) {
  return service({
    url: "admin/Wenxue/getDynasty",
    method: "POST",
    data: options,
  });
}

export function addDynasty(options) {
  return service({
    url: "admin/Wenxue/addDynasty",
    method: "POST",
    data: options,
  });
}

export function getDynastyDetail(options) {
  return service({
    url: "admin/Wenxue/getDynastyDetail",
    method: "POST",
    data: options,
  });
}

export function editDynasty(options) {
  return service({
    url: "admin/Wenxue/editDynasty",
    method: "POST",
    data: options,
  });
}

export function deleteDynasty(options) {
  return service({
    url: "admin/Wenxue/deleteDynasty",
    method: "POST",
    data: options,
  });
}
/***** 头像管理 ***************************************************/
export function getHeadImg(options) {
  return service({
    url: "admin/Wenxue/getHeadImg",
    method: "POST",
    data: options,
  });
}

export function addHeadImg(options) {
  return service({
    url: "admin/Wenxue/addHeadImg",
    method: "POST",
    data: options,
  });
}

export function deleteHeadImg(options) {
  return service({
    url: "admin/Wenxue/deleteHeadImg",
    method: "POST",
    data: options,
  });
}

/***** 诗人管理 ***************************************************/
export function getAuthor(options) {
  return service({
    url: "admin/Wenxue/getAuthor",
    method: "POST",
    data: options,
  });
}

export function addAuthor(options) {
  return service({
    url: "admin/Wenxue/addAuthor",
    method: "POST",
    data: options,
  });
}

export function getAuthorDetail(options) {
  return service({
    url: "admin/Wenxue/getAuthorDetail",
    method: "POST",
    data: options,
  });
}

export function editAuthor(options) {
  return service({
    url: "admin/Wenxue/editAuthor",
    method: "POST",
    data: options,
  });
}

export function deleteAuthor(options) {
  return service({
    url: "admin/Wenxue/deleteAuthor",
    method: "POST",
    data: options,
  });
}
/***** 诗词 *************************************************/
export function getShici(options) {
  return service({
    url: "admin/Wenxue/getShici",
    method: "POST",
    data: options,
  });
}

export function getShiciDetail(options) {
  return service({
    url: "admin/Wenxue/getShiciDetail",
    method: "POST",
    data: options,
  });
}
/***** 轮播管理 *****************************************************/
export function getShuf(options) {
  return service({
    url: "admin/Wenxue/getShuf",
    method: "POST",
    data: options,
  });
}

export function addShuf(options) {
  return service({
    url: "admin/Wenxue/addShuf",
    method: "POST",
    data: options,
  });
}

export function editShuf(options) {
  return service({
    url: "admin/Wenxue/editShuf",
    method: "POST",
    data: options,
  });
}

export function deleteShuf(options) {
  return service({
    url: "admin/Wenxue/deleteShuf",
    method: "POST",
    data: options,
  });
}

/***** 分类管理 ****************************************************************/
export function getCategory(options) {
  return service({
    url: "admin/Wenxue/getCategory",
    method: "POST",
    data: options,
  });
}

export function addCategory(options) {
  return service({
    url: "admin/Wenxue/addCategory",
    method: "POST",
    data: options,
  });
}

export function editCategory(options) {
  return service({
    url: "admin/Wenxue/editCategory",
    method: "POST",
    data: options,
  });
}
changeAuthorCustom;

export function changeAuthorCustom(options) {
  return service({
    url: "admin/Wenxue/changeAuthorCustom",
    method: "POST",
    data: options,
  });
}

export function deleteCategory(options) {
  return service({
    url: "admin/Wenxue/deleteCategory",
    method: "POST",
    data: options,
  });
}

/***** 景点管理 ****************************************************************/
export function getTravel(options) {
  return service({
    url: "admin/Wenxue/getTravel",
    method: "POST",
    data: options,
  });
}

export function addTravel(options) {
  return service({
    url: "admin/Wenxue/addTravel",
    method: "POST",
    data: options,
  });
}

export function getTravelDetail(options) {
  return service({
    url: "admin/Wenxue/getTravelDetail",
    method: "POST",
    data: options,
  });
}

export function editTravel(options) {
  return service({
    url: "admin/Wenxue/editTravel",
    method: "POST",
    data: options,
  });
}
changeAuthorCustom;

export function changeTravelCustom(options) {
  return service({
    url: "admin/Wenxue/changeTravelCustom",
    method: "POST",
    data: options,
  });
}

export function deleteTravel(options) {
  return service({
    url: "admin/Wenxue/deleteTravel",
    method: "POST",
    data: options,
  });
}

/******** 用户  *************************************************** */
export function getUser(options) {
  return service({
    url: "admin/Wenxue/getUser",
    method: "POST",
    data: options,
  });
}

/******** 支付记录  *************************************************** */
export function getPayRecord(options) {
  return service({
    url: "admin/Wenxue/getPayRecord",
    method: "POST",
    data: options,
  });
}



// WEBPACK FOOTER //
// ./src/utils/wenxue.js